import React from "react";
import styles from "./SiteCertifications.module.scss";
import CDPSVG from "./CDPSVG";
import LogoWithImage from "./LogoWithImage";
import SedexSVG from "./SedexSVG";
import TogetherForSustainabilitySVG from "./TogetherForSustainabilitySVG";
import { getCDNImageUrl } from "@/utils/Common";

function SiteCertifications() {
  return (
    <div className={styles.siteCertifications}>
      {/* Content */}
      <div className={styles.content}>
        <h6>ELCHEMY ADVANTAGE</h6>
        <h2>Site Certifications</h2>
      </div>
      {/* SVGS Row */}
      <div className={styles.row}>
        <LogoWithImage src={getCDNImageUrl("cdp.webp")} alt="CDP Logo" />
        <LogoWithImage
          src={getCDNImageUrl("ecovadis.webp")}
          alt="ecovadis Logo"
        />
        <LogoWithImage
          src={getCDNImageUrl("togetherforsustainability.webp")}
          alt="Together For Sustainability Logo"
        />
        <LogoWithImage
          src={getCDNImageUrl("sedex.webp")}
          alt="sedex Logo"
          height={70}
          width={70}
        />
      </div>
    </div>
  );
}

export default SiteCertifications;
